module.exports = {"140922100":"台城镇","140922102":"耿镇镇","140922103":"豆村镇","140922104":"白家庄镇","140922105":"东冶镇","140922200":"沟南乡","140922201":"东雷乡","140922202":"高洪口乡","140922203":"门限石乡","140922204":"陈家庄乡","140922205":"建安乡","140922206":"神西乡","140922207":"蒋坊乡","140922208":"灵境乡","140922209":"阳白乡","140922210":"茹村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140922.json
// module id = 348
// module chunks = 0